function responsiveEmbed() {
  // Get iframes
  const iframes = [...document.querySelectorAll('[data-blog-content] iframe')];

  iframes.forEach((iframe) => {
    const div = document.createElement('div');

    div.className = 'o-media o-media--video';
    iframe.parentElement.insertBefore(div, iframe);
    div.appendChild(iframe);
  });
}

export function init() {
  responsiveEmbed();
}
